import superMario1 from "../../../assets/images/background/super_mario/1.png";
import superMario2 from "../../../assets/images/background/super_mario/2.png";
import superMario3 from "../../../assets/images/background/super_mario/3.png";
import superMario4 from "../../../assets/images/background/super_mario/4.png";
import superMario5 from "../../../assets/images/background/super_mario/5.png";
import superMario6 from "../../../assets/images/background/super_mario/6.png";
import superMario7 from "../../../assets/images/background/super_mario/7.png";
import superMario8 from "../../../assets/images/background/super_mario/8.png";
import superMario9 from "../../../assets/images/background/super_mario/9.png";
import superMario10 from "../../../assets/images/background/super_mario/10.png";
import superMario11 from "../../../assets/images/background/super_mario/11.png";

const superMario = {
	name: "Super Mario",
	components: {
		superMario_1: {
			id: "superMario_1",
			image: superMario1,
			text: "superMario tile 1",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		superMario_2: {
			id: "superMario_2",
			image: superMario2,
			text: "superMario tile 2",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 0 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
			],
			waters: [],
		},
		superMario_3: {
			id: "superMario_3",
			image: superMario3,
			text: "superMario tile 3",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		superMario_4: {
			id: "superMario_4",
			image: superMario4,
			text: "superMario tile 4",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		superMario_5: {
			id: "superMario_5",
			image: superMario5,
			text: "superMario tile 5",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 13, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 13, y2: 41 },
			],
			waters: [],
		},
		superMario_6: {
			id: "superMario_6",
			image: superMario6,
			text: "superMario tile 6",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		superMario_7: {
			id: "superMario_7",
			image: superMario7,
			text: "superMario tile 7",
			pois: { name: "", items: [] },
			walls: [],
			waters: [],
		},
		superMario_8: {
			id: "superMario_8",
			image: superMario8,
			text: "superMario tile 8",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		superMario_9: {
			id: "superMario_9",
			image: superMario9,
			text: "superMario tile 9",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		superMario_10: {
			id: "superMario_10",
			image: superMario10,
			text: "superMario tile 10",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
				{ x1: 0, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
			],
			waters: [],
		},
		superMario_11: {
			id: "superMario_11",
			image: superMario11,
			text: "superMario tile 11",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 11 },
				{ x1: 41, y1: 11, x2: 59, y2: 11 },
				{ x1: 59, y1: 11, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
	},
};

export default superMario;
